<template lang="pug">
v-container(fluid class=" pt-2 pb-0 tw-mb-0 tw-pb-0 tw-h-full tw-overflow-hidden tw-mx-0 tw-px-3 ")
  div(class=" tw-flex tw-flex-col tw-h-full  tw-overflow-hidden ")
    div(class=" tw-flex-col ")
      v-row(no-gutters class="mx-1 rounded-lg tw-bg-gray-lighten-5 tw-border-gray-lighten-3 tw-border")
        v-col(class="")
          v-row(no-gutters align="center" justify="space-between")
            v-col(cols="auto" class="pl-2")
              v-row(align="center" no-gutters)
                v-col(cols="auto" class="tw-ml-0 tw-pl-0")
                  v-checkbox(
                    @click="checkAll()"
                    :value="checkAllValue"
                    :indeterminate="checkAllValue == 'indeterminate' ? true : false"
                    :ripple="false"
                    color="indigo lighten-2"
                    class="tw-mr-0 tw-ml-2 tw-pr-0"
                  )
                v-col(cols="auto" class=" tw-mr-0 tw-pr-0")
                  v-menu(offset-y nudge-right dark class="tw-mx-0 tw-px-0" :disabled="selection.length > 0 ? false : true")
                    template(v-slot:activator="{ on, attrs }")
                      v-btn(
                        @click=""
                        v-bind="attrs"
                        width="5"
                        min-width="5"
                        dense
                        color="blue-grey"
                        plain
                        tile
                        text
                        :ripple="false"
                        v-on="on"
                        class=" tw-p-0 k-btn-context"
                        :disabled="selection.length > 0 ? false : true"
                      )
                        v-icon(size="26px" class=" tw-pl-0 tw--mr-2 tw--ml-4 tw-mb-0") mdi-menu-down
                    v-list(dense)
                      //- v-list-item(class="tw-px-0")
                      //-   v-btn(@click="" text block class="my-0")
                      //-     v-row(dense class="tw-cursor-pointer")
                      //-       v-col(cols="auto")
                      //-         v-icon(small color="white") mdi-share
                      //-       v-col(cols="auto")
                      //-         span(class=" tw-text-white tw-font-bold") Share
                      v-list-item(class="tw-px-0")
                        v-btn(@click="update(2)" text block class="my-0")
                          v-row(dense class="tw-cursor-pointer")
                            v-col(cols="auto")
                              v-icon(small color="white") mdi-check-decagram
                            v-col(cols="auto")
                              span(class=" tw-text-white tw-font-bold") Considering
                      v-list-item(class="tw-px-0")
                        v-btn(@click="update(3)" text block class="my-0")
                          v-row(dense class="tw-cursor-pointer")
                            v-col(cols="auto")
                              v-icon(small color="white") mdi-close-circle
                            v-col(cols="auto")
                              span(class=" tw-text-white tw-font-bold") Discard
                      v-list-item(class="tw-px-0")
                        v-btn(@click="deleteItems()" text block class="my-0")
                          v-row(dense class="tw-cursor-pointer")
                            v-col(cols="auto")
                              v-icon(small color="white") mdi-trash-can
                            v-col(cols="auto")
                              span(class=" tw-text-white tw-font-bold") Delete

            v-col(cols="auto" class="mr-2")
              v-btn(
                fab
                small
                @click="addPitch"
                color="indigo lighten-5"
                depressed
                v-ripple="true"
              )
                v-icon(x-large color="indigo lighten-1") mdi-plus
    div(class="  tw-flex-col tw-flex-1 tw-overflow-y-scroll tw-overflow-x-hidden tw-pt-2  " :key="key")
      template(v-if="!loading && pitches.length > 0")
        v-row(dense class=" tw-max-h-main tw-overflow-y-scroll")
          v-col(class=" tw-overflow-y-scroll px-2" :key="key")
            kubiqa-pitches-list-item(
              v-for="pitch in pitches"
              :key="pitch.id"
              :item="pitch.property"
              :pitch="pitch"
              class="tw-mb-1"
              :show_menu="true"
              :status="pitch.status"
            )
      template(v-else-if="!loading && pitches.length < 1")
        v-row(dense justify="center" align="center" class="tw-max-h-main tw-h-full tw-overflow-y-scroll ")
          v-col(cols="auto")
            kubiqa-misc-empty-state(
              :title="$t('Common.emptyStates.pitchesTitle')"
              :description="$t('Common.emptyStates.pitchesBody')"
              :illustration="require('@/assets/images/illustrations/empty-pitches.svg')"
            )
      template(v-if="loading")
        kubiqa-misc-loading
  v-dialog(v-model="dialog" max-width="35%" hide-overlay class="tw-ml-32")
    div(class=" k-pitch-detail-dialog tw-bg-white")
      kubiqa-pitches-detail
  v-dialog(v-model="addPitchDialog" max-width="65%" class="tw-ml-32")
    div(class="tw-bg-white")
      kubiqa-pitches-add(@close="addPitchDialogToggle" :key="key")
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      detail: null,
      addPitchDialog: false,
      key: 1,
      loading: true,
    };
  },
  computed: {
    opportunity() {
      return this.$route.params.id;
    },
    pitches() {
      return this.$store.getters['opportunities/pitches/list'];
    },
    selection: {
      get() {
        return this.$store.getters['opportunities/pitches/selection'];
      },
      set(selection) {
        return this.$store.commit('opportunities/pitches/SET_SELECTION', selection);
      },
    },
    checkAllValue() {
      let value = null;
      if (this.selection.length > 0 && this.selection.length == this.pitches.length) {
        value = true;
      }
      if (this.selection.length > 0 && this.selection.length < this.pitches.length) {
        value = 'indeterminate';
      }
      if (this.selection.length == 0) {
        value = false;
      }
      return value;
    },
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch('opportunities/pitches/list', this.opportunity);
    this.key++;
    this.loading = false;
  },
  methods: {
    onDetail: function (detailItem) {
      this.dialog = true;
      this.detail = detailItem;
    },
    addPitch() {
      this.selection = [];
      this.$store
        .dispatch('opportunities/pitches/list', this.opportunity)
        .then(() => {
          this.addPitchDialog = !this.addPitchDialog;
          this.key++;
        })
        .catch((error) => {
          commit('SET_ERROR', error, { root: true });
        });
    },
    update(status) {
      let pitches = [];
      this.selection.forEach((item) => {
        let pitch = {};
        pitch = this.lodash.find(this.pitches, { id: item });
        pitch.status = status;
        pitches.push(pitch);
      });
      this.$store.dispatch('opportunities/pitches/update', [this.opportunity, pitches]);
    },
    deleteItems() {
      let pitches = [];
      this.selection.forEach((item) => {
        let pitch = {};
        pitch = this.lodash.find(this.pitches, { id: item });
        pitches.push(pitch);
      });
      this.$store.dispatch('opportunities/pitches/delete', [this.opportunity, pitches]);
    },
    getPitchList() {},
    addPitchDialogToggle() {
      this.addPitchDialog = !this.addPitchDialog;
    },
    checkAll() {
      if (this.selection.length == this.pitches.length) {
        this.selection = [];
      } else {
        let selection = [];
        this.pitches.forEach((pitch) => {
          selection.push(pitch.id);
        });
        this.selection = selection;
      }
    },
  },
};
</script>
<style scoped>
.k-pitch-detail-dialog {
  height: 520px;
  overflow: hidden;
  min-height: 520px;
}
.k-btn-context {
  padding: 0 !important;
}
</style>
